document.write('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/ui-1.11.0/themes/base/core.min.css" />');
document.write('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/ui-1.11.0/themes/base/datepicker.min.css" />');
document.write('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/ui-1.11.0/themes/base/slider.min.css" />');
document.write('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/ui-1.11.0/themes/base/resizable.min.css" />');
document.write('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/ui-1.11.0/themes/base/theme.min.css" />');

if (Config.languageISOCode == 'pt') {
  document.write('<script type="text/javascript" src="/libs/vendor/jquery/ui-1.11.0/minified/i18n/datepicker-pt-BR.min.js"></script>');
}
else if (Config.languageISOCode == 'zh') {
  document.write('<script type="text/javascript" src="/libs/vendor/jquery/ui-1.11.0/minified/i18n/datepicker-zh-CN.min.js"></script>');
}
else if (Config.languageISOCode == 'tl') {
  document.write('<script type="text/javascript" src="/libs/vendor/jquery/ui-1.11.0/minified/i18n/datepicker-fil.min.js"></script>');
}
else if (Config.languageISOCode != 'en') {
  document.write('<script type="text/javascript" src="/libs/vendor/jquery/ui-1.11.0/minified/i18n/datepicker-'+Config.languageISOCode+'.min.js"></script>');
}

function datepickerInit (element) {
  var dateFormat = (Config.dateFormat).toLowerCase(),
      year = parseInt((new Date()).getFullYear());

  $(!!element? element : document).find("input.calendar-input").datepicker({
    "dateFormat": dateFormat.replace("yyyy", "yy"),
    "changeYear": true,
    "yearRange": (year-85)+":"+(year+1),
    "showOn": "both",
    "buttonText": ""
  })
  .each(function() {
    var el = $(this),
        maxDate = el.attr("data-maxDate");

    if (maxDate) el.datepicker("option", "maxDate", maxDate);
    if (el.prop("disabled")) el.datepicker("option", "disabled", true);

    var icon = document.createElement("i");
    icon.classList.add("fi", "fi-rr-calendar");
    this.nextSibling.appendChild(icon);
  });

}

$(function() {
  datepickerInit();
});